import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import {
  DaymadeDesignSystemPreviewComponent,
  DaymadeDesignSystemPreviewComponentInfo,
} from '.';
import React from 'react';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import ExpandableOrderSummary from 'components/enter2026/ExpandableOrderSummary';
import OrderSummaryRows from 'components/enter2026/OrderSummaryRows';
import OrderSummaryCosts from 'components/enter2026/OrderSummaryCosts';
import RoundedButton from 'components/RoundedButton';
import { observer } from 'mobx-react-lite';
import { MainDrawDay } from 'constants/Draw';
import HeaderOrderSummary from 'components/enter2026/HeaderOrderSummary';

const ComponentPreview = observer(() => {
  const enterStore = useEnterStore();

  return (
    <AboutUsModule background="white">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">Enter store controls</h3>
        <div>
          <RoundedButton
            mini
            onClick={() => {
              if (enterStore.num_entries === 4) {
                enterStore.setNumEntries(1);
              } else {
                enterStore.setNumEntries(enterStore.num_entries + 1);
              }
            }}
          >
            Toggle entry count
          </RoundedButton>{' '}
          <RoundedButton
            mini
            onClick={() => {
              if (enterStore.days[0] === MainDrawDay.FRIDAY) {
                enterStore.setDays([MainDrawDay.TUESDAY, MainDrawDay.FRIDAY]);
              } else if (enterStore.days.length === 2) {
                enterStore.setDays([MainDrawDay.TUESDAY]);
              } else {
                enterStore.setDays([MainDrawDay.FRIDAY]);
              }
            }}
          >
            Toggle days
          </RoundedButton>{' '}
          <RoundedButton
            mini
            onClick={() => {
              enterStore.setBoosted(!enterStore.boosted);
            }}
          >
            Toggle boost count
          </RoundedButton>
        </div>

        <h3 className="aboutUsTypographyHeaderLarge">
          Enter flow order summary
        </h3>
        <p>The order summary that appears on most pages of the enter flow</p>
        <div style={{ maxWidth: 490, marginBottom: 24 }}>
          <ExpandableOrderSummary showDays={true} />
        </div>
        <h3 className="aboutUsTypographyHeaderLarge">
          Enter flow order summary
        </h3>
        <p>Just the order summary rows</p>
        <div style={{ maxWidth: 490, marginBottom: 24 }}>
          <OrderSummaryRows showDays={true} />
        </div>
        <h3 className="aboutUsTypographyHeaderLarge">Enter flow order costs</h3>
        <p>Just the order summary costs</p>
        <div style={{ maxWidth: 490, marginBottom: 24 }}>
          <OrderSummaryCosts />
        </div>

        <h3 className="aboutUsTypographyHeaderLarge">HeaderOrderSummary</h3>
        <p>
          This component appears in the header of the enter flow. It is always a
          fixed width. When expanded, it expands to the left, and its width is
          defined by the viewport width. This demo is best viewed on a smaller
          screen
        </p>
        <div style={{ height: 400 }}>
          <div style={{}}>
            <HeaderOrderSummary />
          </div>
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
}) as DaymadeDesignSystemPreviewComponent;

// We must cast as any when we are putting an observable component into the design system. Normally, we just throw
// properties on a Functional component (which is just a JS function)
ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Enter Flow Order Summary',
};

export default ComponentPreview;
